import { Avatar, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { colors } from "../../../theme/palette";

interface EventCardOrganizerProps {
  authorName: string;
  authorMedia: string;
  authorFirstTwoChr: string;
}

const EventCardOrganizer = ({ authorName, authorMedia, authorFirstTwoChr }: EventCardOrganizerProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", rowGap: "6px" }}>
      <Typography variant="body12SemiBold" sx={{ color: colors.Dark600 }}>
        {t("pages.events.eventList.organizer")}
      </Typography>
      <Box sx={{ display: "flex", columnGap: "8px", alignItems: "center" }}>
        <Avatar
          src={authorMedia}
          sx={{
            width: "24px",
            height: "24px",
            fontSize: "10px",
          }}
        >
          {authorFirstTwoChr}
        </Avatar>
        <Typography
          variant="body12SemiBold"
          sx={{
            color: colors.Dark1000,
            fontWeight: 700,
            display: "flex",
            columnGap: "8px",
            alignItems: "center",
          }}
        >
          {authorName}
        </Typography>
      </Box>
    </Box>
  );
};

export default EventCardOrganizer;
